import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import Faqs from "@components/Faqs";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const FaqPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout minimal>
            <Helmet>
                <title>{`${brand} | ${whiteLabel?.brand_title}`}</title>
                <meta name="keywords" content={`${brand} | ${whiteLabel?.brand_title}`} />
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href={`${window.location.protocol}//${window.location.host}/faqs`} />
            </Helmet>
            <Faqs />
        </VersionedLayout>
    );
};

export default FaqPage;
